import "./GanttTooltip.css";

import { JSX } from "react/jsx-runtime";

import { TOOLTIP_MAX_WIDTH, TOOLTIP_OFFSET } from "../../constants";
import { GanttTooltipProps } from "../../models";

export const GanttTooltip = ({ data, x, y }: GanttTooltipProps): JSX.Element => {
  // Flip to the left of the cursor when near the right viewport edge.
  const viewportWidth = typeof window !== "undefined" ? window.innerWidth : TOOLTIP_MAX_WIDTH * 2;
  const flipLeft = x + TOOLTIP_OFFSET + TOOLTIP_MAX_WIDTH > viewportWidth;
  const left = flipLeft ? x - TOOLTIP_OFFSET - TOOLTIP_MAX_WIDTH : x + TOOLTIP_OFFSET;

  return (
    <div className="GanttTooltip" style={{ left, top: y + TOOLTIP_OFFSET }} role="tooltip">
      <div className="GanttTooltipTitle body3">
        {data.accentColor && (
          <span className="GanttTooltipAccent" style={{ backgroundColor: data.accentColor }} aria-hidden="true" />
        )}
        <span className="GanttTooltipTitleText">{data.title}</span>
      </div>
      {data.meta.length > 0 && (
        <dl className="GanttTooltipMeta">
          {data.meta.map((m) => (
            <div key={m.label} className="GanttTooltipMetaRow">
              <dt className="GanttTooltipMetaLabel body4">{m.label}</dt>
              <dd className="GanttTooltipMetaValue body4">{m.value}</dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  );
};
